import type { IValidationResult, IValidatorParams } from "@edaz/services/baseValidationService";

export interface IsLengthOptions {
  min?: number;
  max?: number;
  optional?: boolean;
  reverseMin?: number;
  reverseMax?: number;
  reverseProperty?: string;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export default function isLength(
  // tslint:disable-next-line:max-union-size
  value: string | number | undefined | null,
  options: IsLengthOptions,
  params?: IValidatorParams
): IValidationResult {
  if (options.optional && !value) {
    return {
      isValid: true,
    };
  }

  let isValid = true;
  let reverse = false;
  const constraints: any = {};
  let valueLength = `${value}`.length;
  if (options.reverseProperty && !params?.entity[options.reverseProperty]) {
    reverse = true;
    valueLength = options.reverseMax ?? 0;
  }
  if (!reverse && options.min && valueLength < options.min) {
    isValid = false;
    constraints.min = valueLength;
  }

  if (!reverse && options.max && valueLength > options.max) {
    isValid = false;
    constraints.max = valueLength;
  }
  if (reverse && options.reverseMin && valueLength <= options.reverseMin) {
    isValid = false;
    constraints.min = valueLength;
  }

  if (reverse && options.reverseMax !== undefined && valueLength >= options.reverseMax) {
    isValid = false;
    constraints.max = valueLength;
  }

  if (reverse) {
    return {
      isValid,
      errors: {
        constraints,
        params: [(options?.reverseMin ?? 0).toString(), (options?.reverseMax ?? Infinity).toString()],
      },
    };
  }
  return {
    isValid,
    errors: {
      constraints,
      params: [(options?.min ?? 0).toString(), (options?.max ?? Infinity).toString()],
    },
  };
}
